@for (sectionContent of section.sectionContents; track $index) {
  <campus-froala-viewer
    class="[ container ]"
    data-cy="section-content"
    [content]="sectionContent.eduContent?.publishedEduContentMetadata?.data | mathjax"
  ></campus-froala-viewer>
}
